import { gql } from '@apollo/client'

export const SEND_EMAIL_FORM = gql`
  mutation SEND_EMAIL_FORM($stingifiedObject: String!, $language: Language!) {
    sendEmailForm(stingifiedObject: $stingifiedObject, language: $language)
  }
`
